import { render, staticRenderFns } from "./chat_messaggio.vue?vue&type=template&id=2f4fa16f&scoped=true&"
import script from "./chat_messaggio.vue?vue&type=script&lang=js&"
export * from "./chat_messaggio.vue?vue&type=script&lang=js&"
import style0 from "./chat_messaggio.vue?vue&type=style&index=0&id=2f4fa16f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4fa16f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VDialog,VIcon,VImg,VProgressCircular,VRow})
